import { AuthenticationResult } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { useContext } from "react";
import { UserGroup } from "../enums/UserGroup";
import VspPortalContext from "../store/VspPortalContext";
import { adGroups } from "./adGroups.data";
import { VspPortalActions } from "../store/VspPortalActions";



export const useAuth = ( ): {

    authorize( ): Promise<boolean>
    , getIdToken( ): Promise<string>
    , logout( ) : Promise< void >

} => {

  const { dispatch } = useContext( VspPortalContext );
  
  const { instance, accounts } = useMsal( );
  

  const authorize = async ( ): Promise<boolean> => {

      const authenticationResult: AuthenticationResult = await getAuthenticationResult( );

      const groups: string[] = authenticationResult.account?.idTokenClaims?.groups as string[];
      const agGroupGuids: string[] = adGroups.map( g => g.guid );
      
      const intersection = groups.filter( e => agGroupGuids.includes ( e ) );

      if( intersection.length > 0 ) {

        const userGroups: UserGroup[] = [];

        for( const agGroupGuid of intersection ) {

          userGroups.push( ( adGroups.find( ag => ag.guid === agGroupGuid )?.name as UserGroup ) );

        }

        dispatch({ type: VspPortalActions.SetUserGroups, payload: userGroups });
        
        if( authenticationResult.account?.name ) {

          dispatch({ type: VspPortalActions.SetUserName, payload: authenticationResult.account.name });

        }

        return true;

      }

      return false;

  }
 

  const getAuthenticationResult = async( ): Promise<AuthenticationResult> => {

      const tokenRequest = {
        scopes: ['User.Read'],
        account : accounts[0],
        forceRefresh: true
      };

      return await instance.acquireTokenSilent( tokenRequest );

  }


  const getIdToken = async( ): Promise<string> => {

    const authenticationResult: AuthenticationResult = await getAuthenticationResult( );
    return authenticationResult.idToken;

    // const idTokenExpiry: number = ( authenticationResult.idTokenClaims as any ).exp;
    // const timestampInSeconds = Math.floor(Date.now() / 1000 );

  };


  const logout = async( ) : Promise< void > => await instance.logout();


  return {

      authorize
      , getIdToken
      , logout

  };

};